export default {"src":"/_next/static/media/instagram.8f3dc296.svg","height":14,"width":14};